__turbopack_context__.v({
  "alternativeColour": "AsSeenOn-module__ICOjTW__alternativeColour",
  "asSeenOn": "AsSeenOn-module__ICOjTW__asSeenOn",
  "channel4": "AsSeenOn-module__ICOjTW__channel4",
  "financialTimes": "AsSeenOn-module__ICOjTW__financialTimes",
  "sky": "AsSeenOn-module__ICOjTW__sky",
  "theGuardian": "AsSeenOn-module__ICOjTW__theGuardian",
  "title": "AsSeenOn-module__ICOjTW__title",
});
